module.exports = __webpack_public_path__ + "img/edits-trash.8a85bfff.svg";